// Chart configuration constants
export const CHART_CONFIG = {
  BAR_CATEGORY_GAP: '10%',
  BAR_GAP: 0,
  CHART_HEIGHT: 500,
  LABEL_MAX_CHARS_PER_LINE: 15,
  BASELINE_MOCK_MULTIPLIER: 0.8,
  TOTAL_POPULATION: 5174,
};

// Chart margins
export const CHART_MARGINS = {
  top: 40, // Increased for label space
  right: 10,
  left: 10,
  bottom: 80, // Increased for rotated X-axis labels
};

// Risk level colors
export const RISK_COLORS = {
  CRITICAL: '#e74c3c',    // Red - for imminent, suicide, safety
  HIGH: '#f39c12',        // Orange - for risk, depression, anxiety
  MONITOR: '#3498db',     // Blue - default/monitor
  HELP_REQUESTED: '#27ae60', // Green - for help, requested, seeking
};

// Risk level keywords for color determination
export const RISK_KEYWORDS = {
  CRITICAL: ['imminent', 'suicide', 'safety'],
  HIGH: ['risk', 'depression', 'anxiety'],
  HELP_REQUESTED: ['help', 'requested', 'seeking'],
};
